import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAccessToken } from '../../utils/authHelpers';
import { PASSWORD_SETUP_EVENT, needsPasswordSetup } from '../../utils/passwordSetup';

// 오른쪽 아래 Weglot 언어 선택 창은 들어오는 길(첫 화면·로그인·회원가입·비밀번호 재설정)과
// 초기 비밀번호 온보딩 창에서만 보인다. 2026-10-07 대표님 요청: «우측하단 언어선택 삭제, 회원가입 온보딩에서는 유지»
// → 같은 날 «로그인 온보딩, 비번 온보딩, 첫 화면에서도 보여야 함». 로그인한 뒤에는 사이드바 언어 메뉴(LanguageModal)로 바꾼다.
// Weglot 이 창을 body 에 직접 붙이므로 body 표시를 바꾸고, 숨김은 index.css 가 한다.
// 창의 z-index 가 최댓값이라 비밀번호 온보딩 창(z-[10000]) 위에도 보인다.
export const SWITCHER_VISIBLE_CLASS = 'wg-switcher-visible';
const ENTRY_PATHS = [
  '/',
  '/login',
  '/login-email',
  '/login-influencer-email',
  '/signup',
  '/signup-influencer',
  '/reset-password',
];

export function isEntryPath(pathname) {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return ENTRY_PATHS.includes(path);
}

export default function LanguageSwitcherVisibility() {
  const { pathname } = useLocation();
  const [passwordOnboarding, setPasswordOnboarding] = useState(() => needsPasswordSetup());

  useEffect(() => {
    const sync = () => setPasswordOnboarding(needsPasswordSetup());
    window.addEventListener(PASSWORD_SETUP_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(PASSWORD_SETUP_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  // 비밀번호 온보딩 창이 뜨는 조건(PasswordOnboardingGate)과 같게 — 표시와 토큰이 함께 있을 때
  const visible = isEntryPath(pathname) || (passwordOnboarding && !!getAccessToken());
  useEffect(() => {
    document.body.classList.toggle(SWITCHER_VISIBLE_CLASS, visible);
  }, [visible]);
  return null;
}
